module.exports = __webpack_public_path__ + "static/img/Dean.Robinson.ad6690a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dean.Robinson.jpg
// module id = D2n9
// module chunks = 0